var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-10 col box_comment"})
}
var staticRenderFns = []

export { render, staticRenderFns }